import { render, staticRenderFns } from "./NewTransaction.vue?vue&type=template&id=5850f4c9&scoped=true&"
import script from "./NewTransaction.vue?vue&type=script&lang=js&"
export * from "./NewTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850f4c9",
  null
  
)

export default component.exports